module.exports = __webpack_public_path__ + "2ab6d77445159e590879381735de9ff1.png";